import PropTypes from 'prop-types';
import React from 'react';
import Loading from 'components/Loading';
import Error from 'components/Error';

function Form({ children, onSubmit, saving, saveError, loading }) {
  return (
    <form
      className="c-loading-container"
      onSubmit={e => {
        e.preventDefault();
        if (onSubmit) onSubmit();
      }}
    >
      {(saving || loading) && <Loading extraClasses="c-loading--absolute" />}
      {saveError && <Error error={saveError} />}
      {children}
    </form>
  );
}

Form.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  onSubmit: PropTypes.func,
  saving: PropTypes.bool,
  saveError: PropTypes.object,
  loading: PropTypes.bool,
};

export default Form;
